export default __webpack_public_path__ + "static/media/outfit-maison-margiela.6d50af53.jpg";